export default __webpack_public_path__ + "static/media/sachin-resume.a87f6b1b.pdf";